import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import { ProjectsDataTableTableBodyProjectWorkersFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'

interface WorkersProps {
  workers: ProjectsDataTableTableBodyProjectWorkersFragment[]
  totalCount: number
}

const ProjectWorkers = ({ workers, totalCount }: WorkersProps) => {
  const remaining = totalCount - workers.length

  return (
    <Box flexDirection="row" gap="s8" alignItems="center">
      {workers.map(
        (worker) =>
          worker && (
            <Avatar
              size="s24"
              url={buildUrl(worker.access.avatar)}
              label={worker.fullName}
              key={worker.access.id}
            />
          )
      )}
      {remaining !== 0 && <Text size="200">{`+${remaining}`}</Text>}
    </Box>
  )
}

export default ProjectWorkers
